export const FEATURED_CITIES_DEALERS_COUNT = [
  {
    provinceId: 28,
    dealersCount: 1500
  },
  {
    provinceId: 8,
    dealersCount: 1000
  },
  {
    provinceId: 46,
    dealersCount: 500
  },
  {
    provinceId: 41,
    dealersCount: 500
  },
  {
    provinceId: 50,
    dealersCount: 100
  },
  {
    provinceId: 29,
    dealersCount: 300
  },
  {
    provinceId: 30,
    dealersCount: 300
  },
  {
    provinceId: 7,
    dealersCount: 100
  },
  {
    provinceId: 35,
    dealersCount: 100
  },
  {
    provinceId: 48,
    dealersCount: 100
  }
]
